import type { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg fill='none' height={80} width={100} xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={51.264} cy={18.379} fill='#47E487' r={15.543} />
    <path
      d='M59.745 18.363c-.018-1.025-.433-1.849-.927-1.84-.493.009-.878.847-.86 1.872.02 1.025.434 1.849.927 1.84.494-.01.879-.847.86-1.872ZM63.433 18.362c-.019-1.025-.434-1.849-.927-1.84-.494.009-.879.847-.86 1.872.019 1.025.434 1.849.927 1.84.493-.01.878-.847.86-1.872Z'
      fill='#000'
    />
    <circle cx={85.576} cy={61.268} fill='#FCDC78' r={11.809} />
    <path
      d='M88.783 60.956c-.066.03-.103.064-.111.105-.012.033-.003.081.025.143l.774 1.714c.049.108.058.198.028.267-.023.067-.086.123-.188.169l-1.333.597c-.095.043-.18.052-.252.029a.398.398 0 0 1-.17-.204l-3.413-7.553c-.05-.109-.063-.196-.04-.263.03-.07.094-.126.19-.168l2.586-1.16c2.269-1.016 3.847-.54 4.735 1.425.45.995.493 1.882.13 2.661-.367.771-1.115 1.41-2.245 1.917l-.716.32Zm-1.854-4.103c-.066.03-.103.064-.11.105-.012.034-.004.081.024.143l.853 1.889c.028.062.06.103.097.125.032.013.081.005.147-.025l.716-.32c.492-.22.82-.48.986-.778.169-.31.167-.654-.005-1.035-.172-.381-.421-.6-.748-.66-.323-.07-.737.008-1.244.235l-.716.32Z'
      fill='#fff'
    />
    <circle cx={55.901} cy={54.034} fill='#46BAFA' r={23.13} />
    <path
      d='M59.204 45.172c-.41-1.47-1.316-2.5-2.023-2.302-.707.197-.948 1.548-.537 3.018.41 1.469 1.316 2.5 2.023 2.302.707-.197.948-1.549.537-3.018ZM64.52 43.79c-.41-1.469-1.316-2.5-2.023-2.302-.707.197-.947 1.548-.537 3.018.41 1.469 1.316 2.5 2.024 2.302.707-.197.947-1.548.537-3.018Z'
      fill='#000'
    />
    <circle cx={22.721} cy={30.564} fill='#FA474A' r={20.105} />
    <path
      d='M11.151 23.513c.566-1.2.556-2.392-.022-2.664-.577-.272-1.503.48-2.068 1.68-.566 1.199-.556 2.392.021 2.664.578.272 1.504-.48 2.07-1.68ZM15.433 25.626c.565-1.2.555-2.393-.022-2.665-.578-.272-1.504.48-2.07 1.68-.564 1.2-.555 2.392.023 2.664.577.272 1.503-.48 2.069-1.68Z'
      fill='#000'
    />
    <path
      d='M30.717 76.558s2.262-1.11 2.411-1.525c.15-.413.075-5.23.075-5.23l-2.871.659.387 6.096h-.002Z'
      fill='#C4C7D4'
    />
    <path
      d='M33.405 70.156s3.793-1.708 5.092-6.619c.493-1.861-.098-7.906-3.031-10.464-.94-.754-3.047-1.996-5.322-2.332-2.275-.337-12.017-2.07-13.145-2.145-1.128-.074-9.824-.833-12.097 7.917 19.244 4.461 28.506 13.643 28.506 13.643h-.003Z'
      fill='#C4C9D2'
    />
    <path
      d='m24.533 71.624 5.177 4.477s.604.583 1.209.432c.604-.152.735-.923.717-1.6l-.131-4.89-6.972 1.581Z'
      fill='#E5E6EF'
    />
    <path
      d='m28.874 52.26-12.927-2.02c-5.606-.874-10.863 2.941-11.741 8.524-.88 5.582 2.953 10.816 8.558 11.692l12.928 2.018c5.606.875 10.862-2.94 11.741-8.523.879-5.582-2.953-10.817-8.559-11.692Z'
      fill='#E5E6EF'
    />
    <path
      d='M21.863 57.353s2.04-2.06 4.307-.818c2.267 1.242 4.647 6.547-4.847 10.668-.511.226-6.403-3.867-5.78-9.002.113-1.89 3.712-4.939 6.32-.846v-.002Z'
      fill='#C60A09'
    />
    <path
      d='M21.271 57.763s2.04-2.06 4.307-.818c2.267 1.242 4.647 6.547-4.847 10.668-.51.227-6.403-3.867-5.78-9.002.113-1.89 3.712-4.939 6.32-.845v-.003Z'
      fill='#FF554A'
    />
  </svg>
);
export default SvgComponent;
